var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Navbar"),
      _vm._v(" "),
      _c(
        "main",
        [
          _c("FullLoader", { attrs: { loading: _vm.loading } }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 d-flex justify-content-between align-items-center page-header"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "header-action",
                      on: {
                        click: function($event) {
                          return _vm.goToDashboard()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "header-action back",
                        attrs: { src: require("@/assets/images/x.svg") }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("h1", [
                    _c(
                      "span",
                      {
                        staticClass: "underline h1style",
                        on: {
                          click: function($event) {
                            return _vm.goToDashboard()
                          }
                        }
                      },
                      [_vm._v(_vm._s(this.eventDetail.name))]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "path-separator",
                      attrs: {
                        src: require("@/assets/images/path_separator.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "underline",
                        on: {
                          click: function($event) {
                            return _vm.goToDashboard()
                          }
                        }
                      },
                      [_vm._v("Prizes")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "path-separator",
                      attrs: {
                        src: require("@/assets/images/path_separator.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.arg.prizeName))]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "path-separator",
                      attrs: {
                        src: require("@/assets/images/path_separator.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Audit History")])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 history-table" },
                _vm._l(_vm.auditHistory, function(item, index) {
                  return _vm.auditHistory.length > 0
                    ? _c(
                        "div",
                        [
                          _c("div", { staticClass: "history-date" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.historyDate) +
                                "\n              "
                            ),
                            _c("em", [
                              _vm._v(
                                "( All times are displayed in " +
                                  _vm._s(
                                    new Date().toTimeString().split(" ")[1]
                                  ) +
                                  " )"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(item.historyList, function(history) {
                            return _c(
                              "div",
                              {
                                staticClass: "history-row",
                                class: { hideBorder: history.sameTimeOnNext }
                              },
                              [
                                _c("time", [_vm._v(_vm._s(history.time))]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "user",
                                    class: { confirmed: history.isConfirmed }
                                  },
                                  [
                                    _c("span", [_vm._v(_vm._s(history.name))]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "email" }, [
                                      _vm._v("(" + _vm._s(history.email) + ")")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(history.message)
                                  }
                                })
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                }),
                0
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36fe982e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36fe982e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuditHistory.vue
// module id = null
// module chunks = 